<template>
    <div v-if="equipment" class="style-body p-6 bg-white rounded-lg mt-4 shadow-100 lg:w-96">
        <div class="max-w-full w-60 mx-auto mb-2">
            <div v-if="equipment.img">
                <img v-bind:src="equipment.img" v-bind:alt="equipment.model" >
            </div>
            <div v-else>
                <img src="../../assets/default-image.jpg" v-bind:alt="equipment.model" >
            </div>
        </div>
        <table class="full">
            <tr class="py-1">
                <td class="style-title-1 w-16 pr-2">
                    ID
                </td>
                <td class="pl-2">
                    {{ equipment.id }}
                </td>
            </tr>
            <tr v-if="equipment.serial" class="py-1">
                <td class="style-title-1 w-16 pr-2">
                    Serial
                </td>
                <td class="pl-2">
                    {{ equipment.serial }}
                </td>
            </tr>
            <tr v-if="equipment.model" class="py-1">
                <td class="style-title-1 w-16 pr-2">
                    Model
                </td>
                <td class="pl-2">
                    {{ equipment.model }}
                </td>
            </tr>
            <tr>
                <td class="style-title-1 w-16 pr-2">
                    Address
                </td>
                <td class="pl-2">
                    {{ equipment.location }}
                </td>
            </tr>
        </table>
    </div>
</template>

<script charset="utf-8">

export default {
    name: 'EquipmentCard',
    props: ['equipment']
}
</script>
